interface Config {
  onButtonClick?: (el: HTMLButtonElement) => void
}

export default (el: HTMLElement, config: Config = {}): void => {
  el.querySelectorAll<HTMLButtonElement>('button').forEach((buttonEl) => {
    buttonEl.addEventListener('click', (e) => {
      e.preventDefault()
      config.onButtonClick && config.onButtonClick(buttonEl)
    })
  })
}
